import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-expired-invitation-page-error',
  templateUrl: './expired-invitation-page-error.component.html',
  styleUrls: ['./expired-invitation-page-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpiredInvitationPageErrorComponent {}
